import type { RunDialogPageProps } from "..";
import { supportsStreaming } from "../../../code-snippets";
import { useRunDialogContext } from "../context";
import { EndpointDocs } from "../endpoint-docs";
import { snippets } from "../snippets";

export function PredictionAPIPage({
  operations,
  usesVersionlessApi,
  version,
}: RunDialogPageProps) {
  const { language } = useRunDialogContext();
  return (
    <div className="flex flex-col">
      <EndpointDocs
        examples={[
          {
            label: "Create",
            description: "Create a prediction and get the output",
            snippets: snippets("predictions.create.default"),
          },
          supportsStreaming(version._extras) === "none"
            ? null
            : {
                label: "Streaming",
                description: "Create a new prediction and stream the output",
                snippets: snippets("predictions.create.stream"),
              },
          {
            label: "Webhooks",
            description: "Create a new prediction using webhooks",
            snippets: snippets("predictions.create.webhook"),
          },
        ]}
        language={language}
        operation={operations["predictions.create"]}
        usesVersionlessApi={usesVersionlessApi}
        version={version}
      />
      <EndpointDocs
        examples={[
          {
            label: "Get",
            description: "Get the latest version of a prediction by id",
            snippets: snippets("predictions.get.default"),
          },
        ]}
        language={language}
        operation={operations["predictions.get"]}
        usesVersionlessApi={usesVersionlessApi}
        version={version}
      />
      <EndpointDocs
        examples={[
          {
            label: "Cancel",
            description: "Cancel an in progress prediction",
            snippets: snippets("predictions.cancel.default"),
          },
        ]}
        language={language}
        operation={operations["predictions.cancel"]}
        usesVersionlessApi={usesVersionlessApi}
        version={version}
      />
      <EndpointDocs
        examples={[
          {
            label: "List",
            description: "List the first page of your predictions",
            snippets: snippets("predictions.list.default"),
          },
          {
            label: "Paginate",
            description: "Iterate through all your predictions",
            snippets: snippets("predictions.list.pagination"),
          },
        ]}
        language={language}
        operation={operations["predictions.list"]}
        usesVersionlessApi={usesVersionlessApi}
        version={version}
      />
    </div>
  );
}
